module.exports = require("./../../_gen/starling/display/BlendMode");